export default "__VITE_ASSET__d8p8oKuh__"